import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { DrugGroup } from '../_models/drug-group.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class DrugGroupService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }
  private static getDrugGroupsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}&is_active=${filter.isActive}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.isActive) fromString += `&is_active=${filter.isActive}`;
    }

    return fromString;
  }

  createDrugGroup(_drugGroup: DrugGroup) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/drug_groups`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<DrugGroup>(url, _drugGroup, { headers });
  }

  findDrugGroups(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: DrugGroupService.getDrugGroupsListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(
      `${environment.CORE_BASE}/companies/${this.company_id}/drug_groups`,
      { params },
    );
  }

  updateDrugGroup(_drugGroup: DrugGroup): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/drug_groups/${_drugGroup.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<DrugGroup>(url, _drugGroup, { headers });
  }

  deleteDrugGroup(drugGroupId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/drug_groups/${drugGroupId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  searchDrugGroups(term: string): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/drug_groups`;
    const params = new HttpParams({ fromString: 'sort=name,asc&search_term=' + term });
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers, params });
  }
}
